import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(
        Path,
        {
          d: "M5 16V9h14V2H5l14 14h-7m-7 0 7 7v-7m-7 0h7",
          stroke: `${color}`
        }
      )
    }
  );
};
Icon.displayName = "Framer";
const Framer = memo(themed(Icon));
export {
  Framer
};
//# sourceMappingURL=framer.js.map
